import React from 'react';
import { TabsList, TabsTrigger } from "@/components/ui/tabs";

const StatisticsTabs: React.FC = () => {
  return (
    <TabsList className="grid w-full grid-cols-4 lg:w-auto">
      <TabsTrigger value="overview">Overview</TabsTrigger>
      <TabsTrigger value="ebikes">eBikes</TabsTrigger>
      <TabsTrigger value="users">Users</TabsTrigger>
      <TabsTrigger value="rides">Rides</TabsTrigger>
    </TabsList>
  );
};

export default StatisticsTabs;
